<app-megamenu></app-megamenu>

<div class="faq-page">
  <!-- Hero Section -->
  <div class="hero-section">
    <div class="container">
      <div class="hero-content">
        <h1>Frequently Asked Questions</h1>
        <p class="hero-subtitle">Get answers to common questions about our pest control services, safety practices, and what to expect when you choose Complete Pest Control.</p>
      </div>
    </div>
  </div>

  <!-- FAQ Categories -->
  <div class="categories-section">
    <div class="container">
      <h2>Browse by Category</h2>
      <div class="category-filters">
        <div class="chip-container">
          <button 
            *ngFor="let category of categories"
            class="category-chip"
            [class.selected]="selectedCategory === category"
            (click)="selectCategory(category)"
          >
            {{ category }}
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- FAQ Content -->
  <div class="faq-content">
    <div class="container">
      <div class="faq-grid">
        <!-- FAQ List -->
        <div class="faq-list">
          <mat-accordion class="faq-accordion">
            <mat-expansion-panel 
              *ngFor="let faq of filteredFaqs; let i = index" 
              class="faq-panel"
              [expanded]="i === 0 && selectedCategory === 'All'"
              hideToggle="true"
            >
              <mat-expansion-panel-header>
                <mat-panel-title class="faq-question">
                  {{ faq.question }}
                </mat-panel-title>
                <mat-panel-description>
                  <span class="category-badge">
                    {{ faq.category }}
                    <mat-icon class="custom-expansion-icon">expand_more</mat-icon>
                  </span>
                </mat-panel-description>
              </mat-expansion-panel-header>
              
              <div class="faq-answer">
                <p>{{ faq.answer }}</p>
              </div>
            </mat-expansion-panel>
          </mat-accordion>
        </div>

        <!-- Sidebar -->
        <div class="faq-sidebar">
          <mat-card class="help-card">
            <mat-card-header>
              <mat-icon mat-card-avatar>help_center</mat-icon>
              <mat-card-title>Still Have Questions?</mat-card-title>
              <mat-card-subtitle>We're here to help!</mat-card-subtitle>
            </mat-card-header>
            <mat-card-content>
              <p>Can't find the answer you're looking for? Our friendly team is ready to assist you with any questions about our pest control services.</p>
              
              <div class="contact-options">
                <button mat-raised-button class="contact-btn" (click)="callPhone()">
                  <mat-icon>phone</mat-icon>
                  Call {{ config.phone.display }}
                </button>
                <button mat-button class="email-btn" (click)="navigateToContact()">
                  <mat-icon>email</mat-icon>
                  Send Message
                </button>
              </div>
            </mat-card-content>
          </mat-card>

          <mat-card class="service-card">
            <mat-card-header>
              <mat-icon mat-card-avatar>schedule</mat-icon>
              <mat-card-title>Service Hours</mat-card-title>
            </mat-card-header>
            <mat-card-content>
              <div class="hours-list">
                <div class="hours-item">
                  <strong>Monday - Friday:</strong>
                  <span>{{ config.hours.weekdays }}</span>
                </div>
                <div class="hours-item">
                  <strong>Saturday:</strong>
                  <span>{{ config.hours.saturday }}</span>
                </div>
                <div class="hours-item">
                  <strong>Sunday:</strong>
                  <span>{{ config.hours.sunday }}</span>
                </div>
              </div>
            </mat-card-content>
          </mat-card>

          <mat-card class="guarantee-card">
            <mat-card-header>
              <mat-icon mat-card-avatar>verified</mat-icon>
              <mat-card-title>Our Guarantee</mat-card-title>
            </mat-card-header>
            <mat-card-content>
              <p>We stand behind our work with our Complete Pest Guarantee. If pests return between scheduled treatments, we'll come back at no additional cost.</p>
              <button mat-button class="learn-more-btn" routerLink="/services">
                Learn More About Our Services
              </button>
            </mat-card-content>
          </mat-card>
        </div>
      </div>
    </div>
  </div>

  <!-- CTA Section -->
  <div class="cta-section">
    <div class="container">
      <h2>Ready to Get Started?</h2>
      <p>Don't let pests take over your home. Contact us today for a free inspection and customized treatment plan.</p>
      <div class="cta-buttons">
        <button mat-raised-button class="primary-cta" (click)="navigateToContact()">
          <mat-icon>request_quote</mat-icon>
          Get Free Quote
        </button>
        <button mat-button class="secondary-cta" (click)="callPhone()">
          <mat-icon>phone</mat-icon>
          Call {{ config.phone.display }}
        </button>
      </div>
    </div>
  </div>
</div>

<app-footer></app-footer>